export default {
  data() { 
    return {
      startDays: 31,
      dayList: [],
      shortDates: [],
      summaryTable: {
        headers: [
         {text: '', value: 'type'},
        ],
        data: []
      },
      detailTable: {
        headers: [
         {text: '', value: 'type', groupable: false},
         {text: '', value: 'client', groupable: true,},
        ],
        data: []
      },
    }
  },
  methods: {
    getSummaryMetricClass(number) {
      let metricClass
      // this didn't work as a switch?!
      if(number < 50) {
        metricClass = "metric-red";
      } else if (number >= 50 && number < 75 ) {
        metricClass = "metric-yellow";
      } else if(number >= 75) {
          metricClass = "metric-dark-green";
      }
      return metricClass
    }, 
    getMetricClass(number) {
      let metricClass
      if(number < 25) {
        metricClass = "metric-red";
      } else if (number >= 25 && number < 75 ) {
        metricClass = "metric-yellow";
      } else if(number >= 75 && number < 99 ) {
          metricClass = "metric-green";
      } else if(number >= 100  ) {
        metricClass = "metric-dark-green";
      }
      return metricClass
    }, 
    getMetricLabel(number, label) {
      if(label) {
        label = `"${label}"`
      }
      return `${number} ${label}`
    },

    getAverage(sum, useTotalActiveCoaches = false) {
      let len = 0
      if(useTotalActiveCoaches) {
        len = this.totalActiveCoaches
      } else {
        this.table.data.forEach((coach) => coach.computedMetric ? len++ : false)
        if(len == 0) {
          return ''
        }
      }
      let average = sum / len
      return Math.round(average)
    },
    getTeamMetricLabel(number, useTotalActiveCoaches = false) {
      let avg = this.getAverage(number, useTotalActiveCoaches)
      return  avg + ' "' + this.getAverageAnnotation(avg) + '"' 
    },
    getAverageAnnotation(number) {
      // Note, this logic is duplicated in master system. Search for these strings. 
      let label
      if(number < 50) {
        label = "Not sticking to the program"
      } else if (number >= 50 && number < 75 ) {
        label = "Room to improve";
      } else if(number >= 75  ) {
        label = "Keep smashing it!";
      }
      return label
    },
    getNumberForLabel(label) {
      /** 
       * This is a hacky helper method to convert a label into a number. 
       * The number is arbitrarily chosen to be in the range of `getAverageAnnotation`
       * The purpose is that if we have only a label, get a number so that we can compute the `getSummaryMetricClass` or `getMetricClass`
       * Both these methods require a number as param.
      */
      let number
      if(label == 'Not sticking to the program') {
        number = 49
      } else if (label == "Room to improve") {
        number = 70
      } else if(label == "Keep smashing it!"  ) {
        number = 80
      }
      return number
    }
    },
    created() {
      let a = this.$moment().subtract(this.startDays, 'days')
      let b = this.$moment().subtract(1, 'days')
      for (let m = this.$moment(a); m.diff(b, 'days') <= 0; m.add(1, 'days')) {
        let shortDate = m.format('DD-MM')
        let column = { text: shortDate, value:shortDate }
        this.summaryTable.headers.push(column)
        this.detailTable.headers.push(column)
        this.dayList.push(m.format('YYYY-MM-DD'))
        this.shortDates.push(m.format('dd DD-MM'))
      }
    },
  }